import { Inertia } from '@inertiajs/inertia'

function csrfTokenFromMeta() {
  const meta = document.head.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : null
}

function csrfTokenFromInertia() {
  const token = Inertia?.page?.props?.csrf_token
  return typeof token === 'string' && token !== '' ? token : null
}

function resolveCsrfToken() {
  return csrfTokenFromInertia() ?? csrfTokenFromMeta()
}

export function configureAxiosCsrf(axiosInstance) {
  axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  axiosInstance.defaults.withCredentials = true
  axiosInstance.defaults.xsrfCookieName = false

  const token = resolveCsrfToken()
  if (token) {
    axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = token
  }

  axiosInstance.interceptors.request.use((config) => {
    const fresh = resolveCsrfToken()
    if (fresh) {
      config.headers['X-CSRF-TOKEN'] = fresh
    }
    return config
  })
}
